/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BuildingCommand } from './BuildingCommand';
import {
    BuildingCommandFromJSON,
    BuildingCommandFromJSONTyped,
    BuildingCommandToJSON,
    BuildingCommandToJSONTyped,
} from './BuildingCommand';

/**
 * Full building list — existing ones updated by id, new ones (id null) created, missing ones deleted.
 * @export
 * @interface UpdateCopropertyBuildingsCommand
 */
export interface UpdateCopropertyBuildingsCommand {
    /**
     * 
     * @type {Array<BuildingCommand>}
     * @memberof UpdateCopropertyBuildingsCommand
     */
    buildings: Array<BuildingCommand>;
}

/**
 * Check if a given object implements the UpdateCopropertyBuildingsCommand interface.
 */
export function instanceOfUpdateCopropertyBuildingsCommand(value: object): value is UpdateCopropertyBuildingsCommand {
    if (!('buildings' in value) || value['buildings'] === undefined) return false;
    return true;
}

export function UpdateCopropertyBuildingsCommandFromJSON(json: any): UpdateCopropertyBuildingsCommand {
    return UpdateCopropertyBuildingsCommandFromJSONTyped(json, false);
}

export function UpdateCopropertyBuildingsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCopropertyBuildingsCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'buildings': ((json['buildings'] as Array<any>).map(BuildingCommandFromJSON)),
    };
}

export function UpdateCopropertyBuildingsCommandToJSON(json: any): UpdateCopropertyBuildingsCommand {
    return UpdateCopropertyBuildingsCommandToJSONTyped(json, false);
}

export function UpdateCopropertyBuildingsCommandToJSONTyped(value?: UpdateCopropertyBuildingsCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'buildings': ((value['buildings'] as Array<any>).map(BuildingCommandToJSON)),
    };
}

